import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ColorPickerModule } from 'ngx-color-picker';

import { TableModule } from 'primeng/table';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TabViewModule } from 'primeng/tabview';
import { TooltipModule } from 'primeng/tooltip';
import { GalleriaModule } from 'primeng/galleria';
import { CalendarModule } from 'primeng/calendar';
import { AccordionModule } from 'primeng/accordion';
import { PaginatorModule } from 'primeng/paginator';
import { OverlayPanelModule } from 'primeng/overlaypanel';

import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';

import { AutofocusDirective, OnlyNumberDirective, AppTemplateDirective, DisplayDefaultMatrixDirective } from 'app/directive';
import { RightClickDisable } from 'app/directive/right-click-disable.directive';

import {
    CreateUserComponent,
    PdfFontSizeComponent,
    ConfirmTenantChangeComponent,
    AppointmentRequestTrialComponent,
    CategorySearchComponent,
    CategorySearchItemComponent,
    ManualEntryWarrantyComponent,
} from 'app/modules/app-components';
import { PdfPreviewComponent } from 'app/modules/app-components/pdf-preview/pdf-preview.component';

import {
    SwitchCardComponent,
    OverlayImageComponent,
    OverlayVideoComponent,
    OutlineIconBtnComponent,
    AppointmentCardComponent,
    AppColorDropdownComponent,
    AccordianComponent,
    BottomMenuComponent,
    TechnicianTimerComponent,
    AppDividerDropdownComponent,
    ReviewRemindersComponent,
    ConfirmDismissDialogComponent,
    ProcessingDismissDialogComponent,
    ConfirmActionDialogComponent,
    TagComponent,
    TagsListComponent,
    // NotificationsDropdownComponent,
    CustomToasterComponent,
    PaymentReceiptComponent,
    EmailReceiptComponent,
    EmailReceiptResendComponent,
    GroupDatePickerDialogComponent,
    AppToasterComponent,
    DateFilterComponent,
    QboTaostComponent,
    ConfirmInspectionDialogueComponent,
    CalculatorChangeDialogComponent,
    TechnicianDismissDialogComponent,
    UpdateARLimitDialogComponent,
    BulkStatementDialogComponent,
} from 'app/modules/shared/components';
import { AclDialogComponent } from './components/acl-dialog/acl-dialog.component';
import { ShortNumberPipe } from './../../pipe/short-number.pipe';
import { PaymentOptionDialogComponent } from './components/payment-option-dialog/payment-option-dialog.component';
import { DynamicPipe } from 'app/pipe/dynamic.pipe';
import { InitialsPipe } from 'app/pipe/initials.pipe';
import { TimeFromNowPipe } from 'app/pipe/timeFromNow.pipe';
import { CustomerListComponent, DeferredListComponent, OrderServiceListComponent } from '../customers/components';
import { AppointmentTabComponent, InvoiceTabComponent } from '../marketing/components';
import { TaxesComponent } from '../app-components/taxes/taxes.component';
import { AddTaxCodeComponent, AddTaxRateComponent } from '../app-components/taxes/components';
import { HistoryInvSalesChartModule } from '../app-components/history-inv-sales-chart/history-inv-sales.module';
// Generic
import { AppDropdownModule } from './components/app-dropdown/app-dropdown.module';
import { AppInputModule } from './components/input/input.module';
import { AppSwitchPillModule } from './components/switch-pill/switch-pill.module';
import { AppRadioButtonModule } from './components/radio-button/radio-button.module';
import { AppAutoCompleteModule } from './components/auto-complete/auto-complete.module';
import { AppCheckboxModule } from './components/checkbox/checkbox.module';
import { AppTextareaModule } from './components/textarea/textarea.module';
import { AppContentOverlayModule } from './components/content-overlay/content-overlay.module';
import { AppListFilterModule } from '../lists/components/list-filter/list-filter.module';
import { AppOrderFilterModule } from '../workboard/components/order-filter/order-filter.module';
import { AppMultiselectModule } from './components/multiselect/multiselect.module';
import { AppDirectiveModule } from 'app/directive/shared-directive.module';
import { AppMultipleFilterModule } from './components/app-multiple-filter/app-multiple-filter.module';
import { HighlightVinPipe } from 'app/pipe/highlight-vin.pipe';
import { MilageInformationDialogComponent } from './components/milage-information-dialog/milage-information-dialog.component';
import { AppTabLinkModule } from './components/open-tab-link/open-tab-link.module';
import { AppSwitchButtonModule } from './components/switch-button/switch-button.module';
import { KeysPipe } from 'app/pipe/object-key-Iterate.pipe';
import { EstimateDepositDialogComponent } from './components/estimate-deposit-dialog/estimate-deposit-dialog.component';
import { AppCalculateChangeModule } from './components/calculate-change/calculate-change.module';
import { GlobalPaymentDetailsDialogComponent } from './components/global-payment-details-dialog/global-payment-details-dialog.component';
import {
    InventoryTireLookupComponent,
    TireAddToCartDialogComponent,
    TireCartComponent,
    TireDetailsComponent,
    TireLocationSelectDialogComponent,
    TireLookupCardComponent,
    TireShippingRecalculateComponent,
    TireRecommendedSizeComponent,
    TireConnectLookupComponent,
    TireConnectSuppliersComponent,
    TirehubLookupComponent,
    VehicleSpecificLookupDialogComponent,
    TireGlobalCartComponent,
    SubletSupplierDialogComponent,
} from '../estimate/components';
import { ManualOrderingActivityComponent } from '../estimate/components/manual-ordering-activity/manual-ordering-activity.component';
import { AngularImageViewerModule } from 'angular-x-image-viewer';
import { CommissionEarnedDialogComponent } from '../app-components/commission-earned-dialog/commission-earned-dialog.component';
import { AppReportFilterModule } from '../reports/components/report-filter/report-filter.module';
import { HighlightSearchPipe } from 'app/pipe/highlight-search.pipe';
import { PurchaseOrderingActivityComponent } from 'app/modules/estimate/components/purchase-ordering-activity/purchase-ordering-activity.component';
import { ServiceInspectionComponent } from './components/service-inspection/service-inspection.component';
import { GlobalPayBannerComponent } from '../app-components/global-pay-banner/global-pay-banner.component';
import { PinchZoomModule } from '@meddv/ngx-pinch-zoom';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { CustomTranslateLoader } from 'app/services/custom-translate-loader';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie';
import { DataService, HTTPService } from 'app/services';
import { ServiceInspectionLinkedDialogComponent } from './components/service-inspection-linked-dialog/service-inspection-linked-dialog.component';
import { EstimatePreviewDialogComponent } from './components/estimate-preview-dialog/estimate-preview-dialog.component';
import { ReviewRemindersEnhancedEstimateComponent } from './components/review-reminder-enhanced-estimate/review-reminders-enhanced-estimate.component';
import { OutlineIconBtnEnhancedComponent } from './components/outline-icon-btn-enhanced-estimate/outline-icon-btn-enhanced-estimate.component';
import { CustomerPreviewEnhancedComponent } from '../customer/components/customer-preview-enhanced/customer-preview-enhanced.component';
import { ConcernServicePreviewCardEnhancedComponent } from '../customer/components/concern-service-preview-card-enhanced/concern-service-preview-card-enhanced.component';
import { ReviewThanksDialogEnhancedComponent } from '../customer/components/review-thanks-dialog-enhanced/review-thanks-dialog-enhanced.component';
import { EstimateSubmissionHistoryComponent } from '../customer/components/estimate-submission-history/estimate-submission-history.component';
import { SmsCreditHistoryStatusDialog } from './components/sms-credit-history-status/sms-credit-history-status-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        CheckboxModule,
        NgxMaskDirective,
        NgxMaskPipe,
        RouterModule,
        TableModule,
        TabViewModule,
        RadioButtonModule,
        TooltipModule,
        GalleriaModule,
        CalendarModule,
        AccordionModule,
        DragDropModule,
        PaginatorModule,
        ColorPickerModule,
        OverlayPanelModule,
        AppAutoCompleteModule,
        AppDropdownModule,
        AppInputModule,
        AppSwitchPillModule,
        AppSwitchButtonModule,
        AppRadioButtonModule,
        AppCheckboxModule,
        AppTextareaModule,
        AppContentOverlayModule,
        AppListFilterModule,
        AppOrderFilterModule,
        AppDirectiveModule,
        AppMultipleFilterModule,
        AppTabLinkModule,
        AngularImageViewerModule,
        AppReportFilterModule,
        PinchZoomModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useClass: CustomTranslateLoader,
                deps: [HttpClient, CookieService, DataService, HTTPService]
            }
        })
    ],
    declarations: [
        AutofocusDirective,
        OnlyNumberDirective,
        RightClickDisable,
        DisplayDefaultMatrixDirective,
        AccordianComponent,
        ConcernServicePreviewCardEnhancedComponent,
        AppColorDropdownComponent,
        AppointmentCardComponent,
        OverlayImageComponent,
        OverlayVideoComponent,
        OutlineIconBtnComponent,
        SwitchCardComponent,
        BottomMenuComponent,
        TechnicianTimerComponent,
        AppDividerDropdownComponent,
        ReviewRemindersComponent,
        ConfirmDismissDialogComponent,
        ProcessingDismissDialogComponent,
        ConfirmActionDialogComponent,
        TagComponent,
        TagsListComponent,
        ServiceInspectionLinkedDialogComponent,
        EstimatePreviewDialogComponent,
        ReviewRemindersEnhancedEstimateComponent,
        OutlineIconBtnEnhancedComponent,
        CustomerPreviewEnhancedComponent,
        // NotificationsDropdownComponent,
        ConfirmTenantChangeComponent,
        CustomToasterComponent,
        CustomToasterComponent,
        PaymentReceiptComponent,
        EmailReceiptComponent,
        EmailReceiptResendComponent,
        GroupDatePickerDialogComponent,
        AppToasterComponent,
        CreateUserComponent,
        PdfFontSizeComponent,
        PdfPreviewComponent,
        DateFilterComponent,
        AclDialogComponent,
        SmsCreditHistoryStatusDialog,
        ShortNumberPipe,
        HighlightVinPipe,
        DynamicPipe,
        InitialsPipe,
        HighlightSearchPipe,
        TimeFromNowPipe,
        KeysPipe,
        PaymentOptionDialogComponent,
        DeferredListComponent,
        CustomerListComponent,
        OrderServiceListComponent,
        AppointmentTabComponent,
        InvoiceTabComponent,
        TaxesComponent,
        AddTaxCodeComponent,
        AddTaxRateComponent,
        QboTaostComponent,
        ConfirmInspectionDialogueComponent,
        AppointmentRequestTrialComponent,
        MilageInformationDialogComponent,
        EstimateDepositDialogComponent,
        GlobalPaymentDetailsDialogComponent,
        TechnicianDismissDialogComponent,
        InventoryTireLookupComponent,
        TireAddToCartDialogComponent,
        TireCartComponent,
        TireDetailsComponent,
        TireLocationSelectDialogComponent,
        TireLookupCardComponent,
        TireShippingRecalculateComponent,
        TireRecommendedSizeComponent,
        TireConnectLookupComponent,
        TireConnectSuppliersComponent,
        TirehubLookupComponent,
        TireGlobalCartComponent,
        VehicleSpecificLookupDialogComponent,
        ManualOrderingActivityComponent,
        CommissionEarnedDialogComponent,
        UpdateARLimitDialogComponent,
        BulkStatementDialogComponent,
        SubletSupplierDialogComponent,
        PurchaseOrderingActivityComponent,
        CategorySearchComponent,
        CategorySearchItemComponent,
        ServiceInspectionComponent,
        GlobalPayBannerComponent,
        ReviewThanksDialogEnhancedComponent,
        EstimateSubmissionHistoryComponent,
        ManualEntryWarrantyComponent,
    ],
    exports: [
        ShortNumberPipe,
        HighlightVinPipe,
        DynamicPipe,
        InitialsPipe,
        TimeFromNowPipe,
        HighlightSearchPipe,
        KeysPipe,
        AutofocusDirective,
        OnlyNumberDirective,
        RightClickDisable,
        DisplayDefaultMatrixDirective,
        ServiceInspectionLinkedDialogComponent,
        EstimatePreviewDialogComponent,
        ReviewRemindersEnhancedEstimateComponent,
        OutlineIconBtnEnhancedComponent,
        CustomerPreviewEnhancedComponent,
        AccordianComponent,
        AppColorDropdownComponent,
        AppointmentCardComponent,
        OverlayImageComponent,
        OverlayVideoComponent,
        OutlineIconBtnComponent,
        SwitchCardComponent,
        BottomMenuComponent,
        TechnicianTimerComponent,
        AppDividerDropdownComponent,
        ReviewRemindersComponent,
        TagComponent,
        TagsListComponent,
        // NotificationsDropdownComponent,
        CustomToasterComponent,
        ConcernServicePreviewCardEnhancedComponent,
        PaymentReceiptComponent,
        EmailReceiptComponent,
        EmailReceiptResendComponent,
        GroupDatePickerDialogComponent,
        AppToasterComponent,
        PdfFontSizeComponent,
        PdfPreviewComponent,
        CreateUserComponent,
        DateFilterComponent,
        PaginatorModule,
        OverlayPanelModule,
        DeferredListComponent,
        CustomerListComponent,
        OrderServiceListComponent,
        AppointmentTabComponent,
        InvoiceTabComponent,
        TaxesComponent,
        AddTaxCodeComponent,
        AddTaxRateComponent,
        HistoryInvSalesChartModule,
        QboTaostComponent,
        AppAutoCompleteModule,
        AppDropdownModule,
        AppInputModule,
        AppSwitchPillModule,
        AppSwitchButtonModule,
        AppRadioButtonModule,
        AppCheckboxModule,
        AppTextareaModule,
        AppContentOverlayModule,
        AppMultiselectModule,
        AppListFilterModule,
        AppOrderFilterModule,
        AppDirectiveModule,
        AppointmentRequestTrialComponent,
        AppMultipleFilterModule,
        AppCalculateChangeModule,
        ManualOrderingActivityComponent,
        UpdateARLimitDialogComponent,
        BulkStatementDialogComponent,
        PurchaseOrderingActivityComponent,
        CategorySearchComponent,
        CategorySearchItemComponent,
        ServiceInspectionComponent,
        GlobalPayBannerComponent,
        ReviewThanksDialogEnhancedComponent,
        EstimateSubmissionHistoryComponent,
        ManualEntryWarrantyComponent,
    ],
})
export class SharedModule { }
